import type { User } from 'api/data.types'
import { PHX_API_ENDPOINT, SPRINKLR_CHAT_APP_ID } from 'config/vars'
import { ROOTS_IDS_USING_SPRINKLR_CHAT } from './constants'
import { injectSprinklrScript } from './sprinklrScript'
import { getCookie } from 'utils/cookies'

async function fetchHash() {
  const token = getCookie('access_token')

  const request = await fetch(`${PHX_API_ENDPOINT}/chats/sprinklr`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  })

  const response = await request.json()

  return response as {
    email: string
    id: number
    hash: string
    firstName: string
    lastName: string
    phoneNo: string
  }
}

export const initSprinklrChat = async () => {
  try {
    window.sprChatSettings = window.sprChatSettings || {}

    const data = await fetchHash()

    window.sprChatSettings = {
      appId: SPRINKLR_CHAT_APP_ID,
      skin: 'MODERN',
      user: {
        id: data.id || '',
        firstName: data.firstName,
        lastName: data.lastName,
        phoneNo: data.phoneNo,
        email: data.email,
        hash: data.hash
      },
      customContext: {
        _c_650ca62b974b905e0e801637: ''
      }
    }

    injectSprinklrScript()
  } catch (error) {
    console.error('Error starting sprinklr', error)
  }
}

export const shouldShowSprinklrChat = (user: User) => {
  return (
    ROOTS_IDS_USING_SPRINKLR_CHAT.includes(user.reader?.root?.id) ||
    ROOTS_IDS_USING_SPRINKLR_CHAT.includes(user.teacher?.root?.id)
  )
}
